// Every internal route is served as a real directory + index.html on disk
// (react-snap's build output), and sitemap.xml / canonical tags already
// declare every URL with a trailing slash for that reason — without one,
// Apache 301-redirects the request to add it. Internal links built without
// this were forcing every click (and every crawl) through that redirect.
// Route matching itself is unaffected either way — React Router's compiled
// route regex already allows zero-or-more trailing slashes.
export const withTrailingSlash = (path) => {
  if (!path || typeof path !== 'string') return path;
  if (/^https?:\/\//i.test(path) || /^(mailto:|tel:)/i.test(path) || path.startsWith('#')) {
    return path; // external links, mailto/tel, and pure in-page anchors are untouched
  }
  const hashIndex = path.indexOf('#');
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const queryIndex = withoutHash.indexOf('?');
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : '';
  const pathname = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const normalizedPathname = pathname.endsWith('/') ? pathname : `${pathname}/`;
  return normalizedPathname + query + hash;
};

// Rewrite relative hrefs in CMS-authored HTML so they include the PUBLIC_URL
// prefix (plain <a href="/industries/defence"> bypasses React Router's
// basename) and a trailing slash (same reasoning as withTrailingSlash above).
// Was duplicated verbatim in AboutPage.js and DynamicPage.js — consolidated here.
//
// `publicUrl` is '' in production (site served from the domain root). It used
// to bail out on a falsy publicUrl, which silently skipped the trailing-slash
// fix there — CMS links like /industries/defence then went through an Apache
// 301 on every click and crawl. Links to files (/storage/x.pdf) are left
// alone: a slash on those would break them.
const hasFileExtension = (path) => /\.[a-z0-9]{2,5}$/i.test(path.split(/[?#]/)[0]);

export const prefixRelativeLinks = (html, publicUrl = '') => {
  if (!html) return html;
  return html.replace(
    /(<a\s[^>]*href=["'])(\/[^"']*)(["'])/gi,
    (_, open, path, close) => {
      const normalizedPath = hasFileExtension(path) ? path : withTrailingSlash(path);
      if (normalizedPath.startsWith(publicUrl + '/') || normalizedPath === publicUrl) {
        return `${open}${normalizedPath}${close}`;
      }
      return `${open}${publicUrl}${normalizedPath}${close}`;
    }
  );
};
